import PortalMetaCategory from './PortalMetaCategory';
const PortalMetaCategoryIds = {
  [PortalMetaCategory.IMPORT_IMAGE_COPYRIGHT_NOTICE]: 5,
  [PortalMetaCategory.SHUTTERSTOCK_TOS]: 7,
  [PortalMetaCategory.SHUTTERSTOCK_FOLDER_ID]: 8,
  [PortalMetaCategory.DASHBOARD_ADVANCED_SEARCH_POPUP]: 9,
  [PortalMetaCategory.PICKER_ADVANCED_SEARCH_POPUP]: 10,
  [PortalMetaCategory.VIDEO2_OPTIN_NOTICE]: 12
};
export default PortalMetaCategoryIds;